<template>
  <div class="ss__user__identifier">
    <i
      v-popover:userIndentifierPopover
      class="ss__user__identifier__icon"
      :style="{'background-image': `url(${identifier.icon})`}"
    />
    <template v-if="!popoverDisable">
      <el-popover
        ref="userIndentifierPopover"
        popper-class="ss__user__identifier__popover"
        :disabled="popoverDisable"
        trigger="hover"
        :placement="popoverPlacement">
        <div class="identifier__info">
          <div class="identifier__name">{{ identifier.name }}</div>
          <div><a v-if="identifier.url" target="_blank" :href="identifier.url">了解详情 ></a></div>
        </div>
      </el-popover>
    </template>
  </div>
</template>

<script>
import { Popover as ElPopover } from 'element-ui'
export default {
  name: 'SsUserIdentifier',

  components: {
    ElPopover
  },

  props: {
    identifier: {
      type: Object
    },
    popoverDisable: {
      type: Boolean,
      default: false
    },
    popoverPlacement: {
      type: String,
      default: 'bottom'
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__user__identifier {
  display: inline-flex
  .ss__user__identifier__icon {
    display: inline-block
    vertical-align: middle
    background-size: contain
    background-position: center
    background-repeat: no-repeat
    box-sizing: border-box
    width: var(--size-SsUserIdentifierIcon, 16px)
    height: var(--size-SsUserIdentifierIcon, 16px)
  }
}
</style>
<style lang="stylus">
.ss__user__identifier__popover,
.theme-dark .ss__user__identifier__popover {
  border: none
  text-align: center
  font-size: 12px
  padding: 5px 14px
  color: var(--B8-t)
  background: var(--B0-t-overlay)
  border-radius: 0px
  box-shadow: var(--shadow-level-2)
  .popper__arrow {
    border: none
  }
  .popper__arrow::after {
    border-bottom-color: var(--B0-t-overlay)!important
  }
  .identifier__info {
    color: var(--B8-t)
    font-size: 13px
    line-height: 18px
    margin: 0px
    text-align: center
    font-weight: 500
    .identifier__name {
      margin-bottom: 4px
    }
    a {
      color: var(--red)
    }
  }
}
</style>
